import React, { type FC } from 'react'

import classes from './ArticleThumbnail.module.scss'

type ArticleThumbnailProps = {
  imgSrc: string
}

export const ArticleThumbnail: FC<ArticleThumbnailProps> = ({ imgSrc }) => {
  return (
    <div
      className={classes.Thumbnail}
      style={{ backgroundImage: `url(${imgSrc})` }}
    />
  )
}
